// @material-ui/core components
import { makeStyles, useTheme } from "@material-ui/core/styles";

import Box from "@material-ui/core/Box";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
// core componentssrc
import { CardActions, IconButton, Tooltip } from "@material-ui/core";
import { ArrowForwardIos } from "@material-ui/icons";
import componentStylesGeneric from "assets/theme/views/admin/generic";
import TableBackdrop from "components/Backdrops/TableBackdrop/TableBackdrop";
import CardTableContainer from "components/Cards/Tables/CardTableContainer";
import TableStateChip from "components/Cards/Tables/TableStateChip";
import { ConditionGuard } from "guards/ConditionGuard";
import moment from "moment";
import { useFormContext } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { TABLE_STATE_CHIP_COLOR } from "utils/const";

const useStylesGeneric = makeStyles(componentStylesGeneric);

const ResultSection = ({ data, isLoading, onPageChange }) => {
  const theme = useTheme();
  const classes = useStylesGeneric();
  const history = useHistory();
  const location = useLocation();

  const tableHead = ["Data de Submissão", "Nº do Mapa RENT", "Estado", "Nº de Trabalhadores"];

  const { setValue, watch } = useFormContext();

  const pageIndex = watch("pageIndex");

  const mapChipColors = (stateKey) => {
    switch (stateKey) {
      case "Approved":
        return TABLE_STATE_CHIP_COLOR.GREEN;
      case "Rejected":
        return TABLE_STATE_CHIP_COLOR.RED;
      case "Cancelled":
        return TABLE_STATE_CHIP_COLOR.RED;
      case "AwaitingPayment":
      case "PaymentToApprove":
        return TABLE_STATE_CHIP_COLOR.LIGHT_ORANGE;
      case "UnderReview":
        return TABLE_STATE_CHIP_COLOR.BLUE;
      default:
        return <></>;
    }
  };

  // TODO: Implement handleOpenDetails in other US
  const handleOpenDetails = (id) => {
    const from = `${location.pathname}${location.search || ""}`;
    history.push({ pathname: `/admin/rent/details/${id}`, state: { from } });
  };

  function handleChangePage(_, value) {
    setValue("pageIndex", value);

    if (onPageChange) {
      onPageChange(_, value);
    }
  }

  return (
    <>
      <CardTableContainer title="Lista de Mapas RENT submetidos" count={data?.totalRecords}>
        <TableContainer>
          <ConditionGuard condition={!isLoading} fallback={<TableBackdrop open />}>
            <Box component={Table} alignItems="center" marginBottom="0!important">
              <TableHead>
                <TableRow>
                  {tableHead.map((prop, key) => (
                    <TableCell
                      key={key}
                      classes={{
                        root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                      }}
                    >
                      {prop}
                    </TableCell>
                  ))}
                  <TableCell
                    key="detailsCol"
                    classes={{
                      root:
                        classes.tableCellRoot +
                        " " +
                        classes.tableCellRootHead +
                        " " +
                        classes.tableCellHeadStickyRight,
                    }}
                  >
                    Detalhes
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.values?.map((prop, key) => (
                  <TableRow key={key}>
                    <TableCell classes={{ root: classes.tableCellRoot }}>
                      {moment(prop.created).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.name}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>
                      <TableStateChip state={mapChipColors(prop.stateKeyValue)} message={prop.stateDescription} />
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.employeeCount}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellBodyStickyRight }}>
                      <Tooltip title="Detalhes">
                        <IconButton onClick={() => handleOpenDetails(prop.name)}>
                          <Box
                            component={ArrowForwardIos}
                            width="12px!important"
                            height="12px!important"
                            color={theme.palette.primary.main}
                          />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Box>
          </ConditionGuard>
        </TableContainer>

        <Box classes={{ root: classes.cardActionsRoot }} component={CardActions} justifyContent="flex-end"></Box>

        <Pagination
          className={classes.alignPagination}
          count={data?.totalPages}
          page={pageIndex}
          onChange={handleChangePage}
          color="primary"
        />
      </CardTableContainer>

      {!isLoading && data?.values?.length === 0 && (
        <Box classes={{ root: classes.noResultsInfo }}>Não foram encontrados resultados para esta pesquisa.</Box>
      )}
    </>
  );
};

export default ResultSection;
